export function deriveAvatarInitials(
	displayName: string | null | undefined,
	email: string | null | undefined,
	userId: string | null | undefined,
): string {
	const candidateName = displayName?.trim();
	const name = candidateName && !/[<>&]/.test(candidateName) ? candidateName : '';
	if (name) {
		const fromWords = name
			.split(/\s+/)
			.filter(Boolean)
			.map((part) => part[0]?.toUpperCase() ?? '')
			.join('')
			.slice(0, 2);
		if (fromWords.length >= 2) return fromWords;
		const compact = name.replace(/[^a-zA-Z0-9]/g, '');
		if (compact.length >= 2) return compact.slice(0, 2).toUpperCase();
		if (compact.length === 1) return compact.toUpperCase();
	}
	const source = email?.trim() || userId || '';
	if (!source) return '?';
	const at = source.indexOf('@');
	const local = at >= 0 ? source.slice(0, at) : source;
	const cleaned = local.replace(/[^a-zA-Z0-9]/g, '');
	if (cleaned.length >= 2) return cleaned.slice(0, 2).toUpperCase();
	if (cleaned.length === 1) return cleaned.toUpperCase();
	return source.slice(0, 2).toUpperCase();
}
